"use strict";
/*
  Email (MIME) parsing library. Copyright (C) 2020-2021 Vereign AG

  This program is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General
  Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option)
  any later version.

  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied
  warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
  details.

  You should have received a copy of the GNU Affero General Public License along with this program. If not, see
  https://www.gnu.org/licenses/.

  In case of queries or questions, please contact us under by email under contact@vereign.com or by letter post to
  Vereign AG, Kolinplatz 10, 6300 Zug, Switzerland
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROVIDER_VNCMAIL_REGEX = exports.PROVIDER_OUTLOOK_REGEX = exports.PROVIDER_UNKNOWN = exports.PROVIDER_VNCMAIL = exports.PROVIDER_OUTLOOK = exports.PROVIDER_GMAIL = void 0;
exports.PROVIDER_GMAIL = "gmail.com";
exports.PROVIDER_OUTLOOK = "outlook.com";
exports.PROVIDER_VNCMAIL = "vncmail";
exports.PROVIDER_UNKNOWN = "unknown";
exports.PROVIDER_OUTLOOK_REGEX = /(outlook|live|hotmail)\.com/g;
exports.PROVIDER_VNCMAIL_REGEX = /zimbra/g;
